import { SVGProps, type FC } from 'react';

import { AlertIcon } from './icons/Alert';
import { AnalyticsIcon } from './icons/Analytics';
import { ApiVideosIcon } from './icons/ApiVideo';
import { ArrowBottomLeftIcon } from './icons/ArrowBottomLeft';
import { ArrowBottomRightIcon } from './icons/ArrowBottomRight';
import { ArrowDownIcon } from './icons/ArrowDown';
import { ArrowDownBisIcon } from './icons/ArrowDownBis';
import { ArrowLeftIcon } from './icons/ArrowLeft';
import { ArrowRightIcon } from './icons/ArrowRight';
import { ArrowTopLeftIcon } from './icons/ArrowTopLeft';
import { ArrowTopRightIcon } from './icons/ArrowTopRight';
import { ArrowUpIcon } from './icons/ArrowUp';
import { Book } from './icons/Book';
import { BooksIcon } from './icons/Books';
import { BottomChevronIcon } from './icons/BottomChevron';
import { BreakingNewsIcon } from './icons/BreakingNew';
import { CalendarIcon } from './icons/Calendar';
import { CampaignIcon } from './icons/Campaign';
import { CampaignDailySessionIcon } from './icons/CampaignDailySession';
import { CandidatesLikeIcon } from './icons/CandidatesLike';
import { Chart } from './icons/Chart';
import { ChatBubbleWarningIcon } from './icons/ChatBubbleWarning';
import { CheckIcon } from './icons/Check';
import { CheckCircledOutlineIcon } from './icons/CheckCircledOutline';
import { CheckSaveIcon } from './icons/CheckSave';
import { ChevronLeftIcon } from './icons/ChevronLeft';
import { ChevronRightIcon } from './icons/ChevronRight';
import { CloseIcon } from './icons/Close';
import { CloseLightIcon } from './icons/CloseLight';
import { ContentCatalogIcon } from './icons/ContentCatalog';
import { CopyIcon } from './icons/Copy';
import { DeleteIcon } from './icons/Delete';
import { DeleteCircledOutlineIcon } from './icons/DeleteCircledOutline';
import { DotMenuIcon } from './icons/DotMenu';
import { DownloadIcon } from './icons/Download';
import { DragAndDropIcon } from './icons/DragAndDrop';
import { EditIcon } from './icons/Edit';
import { EditSmlIcon } from './icons/EditSml';
import { ErrorIcon } from './icons/Error';
import { ErrorTextIcon } from './icons/ErrorText';
import { ExpandIcon } from './icons/Expand';
import { ExternalLinkIcon } from './icons/ExternalLink';
import { EyeIcon } from './icons/Eye';
import { FallIcon } from './icons/Fall';
import { FilterCampaignIcon } from './icons/FilterCampaign';
import { GameplayIcon } from './icons/Gameplay';
import { GoogleIcon } from './icons/Google';
import { IAIcon } from './icons/IA';
import { ImageIcon } from './icons/Image';
import { ImageUploadIcon } from './icons/ImageUpload';
import { InfoIcon } from './icons/Info';
import { InfoWhatIcon } from './icons/InfoWhat';
import { InterseasonIcon } from './icons/Interseason';
import { KeyboadReturnIcon } from './icons/KeyboardReturn';
import { LanguageIcon } from './icons/Language';
import { Link } from './icons/Link';
import { LockIcon } from './icons/Lock';
import { Lock } from './icons/Lock2';
import { MCQIcon } from './icons/MCQ';
import { ManualOrderIcon } from './icons/ManualOrder';
import { MinusIcon } from './icons/Minus';
import { MixedCheckIcon } from './icons/MixedCheck';
import { NoInteractionIcon } from './icons/NoInteraction';
import { Note } from './icons/Note';
import { NotificationsIcon } from './icons/Notifications';
import { OpenQuestionIcon } from './icons/OpenQuestion';
import { OptionsIcon } from './icons/Options';
import { OrderingCardsIcon } from './icons/OrderingCards';
import { PdfIcon } from './icons/Pdf';
import { PictureSpotIcon } from './icons/PictureSpot';
import { PlaybookIcon } from './icons/Playbook';
import { PlusIcon } from './icons/Plus';
import { PlusCircledIcon } from './icons/PlusCircled';
import { PlusLightIcon } from './icons/PlusLight';
import { PositionBottom } from './icons/PositionBottom';
import { PositionCenter } from './icons/PositionCenter';
import { PositionTop } from './icons/PositionTop';
import { PreviewIcon } from './icons/Preview';
import { PreviewDisabledIcon } from './icons/PreviewDisabled';
import { RadioEmptyIcon } from './icons/RadioEmpty';
import { RadioFilledIcon } from './icons/RadioFilled';
import { RandomOrderIcon } from './icons/RandomOrder';
import { RefreshIcon } from './icons/Refresh';
import { RefreshV2WithGradientIcon } from './icons/RefreshWithGradient';
import { RestoreIcon } from './icons/Restore';
import { RiseIcon } from './icons/Rise';
import { SearchIcon } from './icons/Search';
import { Settings } from './icons/Settings';
import { ShareIcon } from './icons/Share';
import { SparklesIcon } from './icons/Sparkles';
import { SuccessCircleIcon } from './icons/SuccessCircle';
import { SwipingCardsIcon } from './icons/SwipingCards';
import { TargetIcon } from './icons/Target';
import { Target } from './icons/Target2';
import { Teacher } from './icons/Teacher';
import { ThatsAllFolksIcon } from './icons/ThatsAllFolks';
import { Trophy } from './icons/Trophy';
import { UnlockIcon } from './icons/Unlock';
import { UnsplashIcon } from './icons/Unsplash';
import { UploadIcon } from './icons/Upload';
import { UserIcon } from './icons/User';
import { VideoUploadIcon } from './icons/VideoUpload';
import { WarningMiniIcon } from './icons/WarningMini';
import { WelcomeCardIcon } from './icons/WelcomeCard';
import { YoutubeIcon } from './icons/Youtube';

export type Icon = {
  component: FC<SVGProps<SVGSVGElement> & { color: string }>;
};

const iconsMap = {
  alert: AlertIcon,
  analytics: AnalyticsIcon,
  'api-video': ApiVideosIcon,
  'arrow-down': ArrowDownIcon,
  'arrow-down-bis': ArrowDownBisIcon,
  'arrow-top-right': ArrowTopRightIcon,
  'arrow-top-left': ArrowTopLeftIcon,
  'arrow-bottom-left': ArrowBottomLeftIcon,
  'arrow-bottom-right': ArrowBottomRightIcon,
  'arrow-left': ArrowLeftIcon,
  'arrow-right': ArrowRightIcon,
  'arrow-up': ArrowUpIcon,
  book: Book,
  books: BooksIcon,
  'bottom-chevron': BottomChevronIcon,
  'breaking-news': BreakingNewsIcon,
  calendar: CalendarIcon,
  campaign: CampaignIcon,
  'campaign-daily-session': CampaignDailySessionIcon,
  'candidates-like': CandidatesLikeIcon,
  chart: Chart,
  'chat-bubble-warning': ChatBubbleWarningIcon,
  'check-circled-outline': CheckCircledOutlineIcon,
  check: CheckIcon,
  'check-save': CheckSaveIcon,
  'chevron-left': ChevronLeftIcon,
  'chevron-right': ChevronRightIcon,
  close: CloseIcon,
  'close-light': CloseLightIcon,
  'content-catalog': ContentCatalogIcon,
  copy: CopyIcon,
  delete: DeleteIcon,
  'delete-circled-outline': DeleteCircledOutlineIcon,
  'dot-menu': DotMenuIcon,
  download: DownloadIcon,
  'drag-and-drop': DragAndDropIcon,
  edit: EditIcon,
  'edit-sml': EditSmlIcon,
  error: ErrorIcon,
  'error-text': ErrorTextIcon,
  expand: ExpandIcon,
  'external-link': ExternalLinkIcon,
  eye: EyeIcon,
  fall: FallIcon,
  'filter-campaign': FilterCampaignIcon,
  mcq: MCQIcon,
  'no-interaction': NoInteractionIcon,
  note: Note,
  'open-question': OpenQuestionIcon,
  'ordering-cards': OrderingCardsIcon,
  'picture-spot': PictureSpotIcon,
  'swiping-cards': SwipingCardsIcon,
  gameplay: GameplayIcon,
  google: GoogleIcon,
  ia: IAIcon,
  image: ImageIcon,
  'image-upload': ImageUploadIcon,
  info: InfoIcon,
  'info-what': InfoWhatIcon,
  interseason: InterseasonIcon,
  'keyboard-return': KeyboadReturnIcon,
  language: LanguageIcon,
  link: Link,
  lock: LockIcon,
  'lock-2': Lock,
  'manual-order': ManualOrderIcon,
  minus: MinusIcon,
  'mixed-check': MixedCheckIcon,
  notifications: NotificationsIcon,
  options: OptionsIcon,
  pdf: PdfIcon,
  playbook: PlaybookIcon,
  plus: PlusIcon,
  'plus-light': PlusLightIcon,
  'plus-circled': PlusCircledIcon,
  'position-top': PositionTop,
  'position-bottom': PositionBottom,
  'position-center': PositionCenter,
  preview: PreviewIcon,
  'preview-disabled': PreviewDisabledIcon,
  'radio-empty': RadioEmptyIcon,
  'radio-filled': RadioFilledIcon,
  'random-order': RandomOrderIcon,
  refresh: RefreshIcon,
  refreshWithGradient: RefreshV2WithGradientIcon,
  restore: RestoreIcon,
  rise: RiseIcon,
  search: SearchIcon,
  settings: Settings,
  share: ShareIcon,
  sparkles: SparklesIcon,
  'success-circle': SuccessCircleIcon,
  target: TargetIcon,
  'target-2': Target,
  teacher: Teacher,
  'thats-all-folks': ThatsAllFolksIcon,
  trophy: Trophy,
  unlock: UnlockIcon,
  unsplash: UnsplashIcon,
  upload: UploadIcon,
  user: UserIcon,
  'video-upload': VideoUploadIcon,
  'warning-mini': WarningMiniIcon,
  'welcome-card': WelcomeCardIcon,
  youtube: YoutubeIcon,
};

export type IconName = keyof typeof iconsMap;

export const iconsNames = Object.keys(iconsMap) as IconName[];

export type IconMap = Record<IconName, Icon['component']>;

export const ICONS = iconsMap as IconMap;
export default ICONS;

export const TRANSLATION_STATUS_TO_STATUS_TYPE_MAP = {
  not_saved: 'invalid',
  archived: 'invalid',
  draft: 'invalid',
  pending_translation: 'error',
  pending_validation: 'error',
  'waiting-translation': 'error',
  'waiting-validation': 'error',
  ready: 'valid',
  validated: 'valid',
} as const;

export const getTranslationStatusIconOverride = (
  status: 'not_saved' | 'archived' | 'draft' | 'pending_translation' | 'pending_validation' | 'ready',
): IconName | undefined => {
  switch (status) {
    case 'draft':
      return 'edit-sml';
    case 'pending_translation':
      return 'language';
    default:
      return undefined;
  }
};
